import "./styles.scss";
const Spinner = ({ width = 100, height = 100 }) => (
  <div className="loader" style={{ width, height }} />
);

export default Spinner;
